module.exports = __webpack_public_path__ + "static/media/iconfinder_gmail_1220367.c671267f.svg";